<template>
  <div class="main">
    <div class="body" v-for="(item,key) in data" :key=key>
      <div class="border">
        <div class="title">相关专业信息</div>
        <div class="txt" >
          <p style="font-size:20px;font-weight:bold;margin-bottom:20px" >{{key+ 1}}、{{item.ProfessionName}}</p>
          <div v-html="item.Remark"></div>
          <strong>较好院校：</strong> {{item.Colleges}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["zyranking"],
  data() {
    return {
      data: [],
    };
  },
  watch: {
    zyranking() {
      this.getData();
    },
  },
  methods: {
    getData() {
      let listData = [];
      listData = this.zyranking[0].Subject;
      let data = [];
      listData.forEach((element) => {
        if (data.length < 10) {
          if (element.Points > 0) {
            data.push(element.Code);
          }
        }
      });
      this.$fecth.post("Aatest/getData", data).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>


<style scoped lang='less'>
.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  letter-spacing: 1px;
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
